// @ts-check
import { roundToDecimal } from './decimals'

const mlToMg = (ml, percentage) => ml * percentage * 10 * 100
const mgToMl = (mg, percentage) => mg / percentage / 10 / 100
const mlToCart = ml => ml / 1.8
const cartToMl = cart => (cart || 0) * 1.8

// round all to 2
const round = val => roundToDecimal(val, 2)

/**
 * @param {{
 *   mg?: number
 *   ml?: number
 *   cartridges?: number
 *   drugPercent: number
 * }} param0
 * @returns {{
 *   cartridges: number
 *   ml: number
 *   mg: number
 * }}
 */
export const convertLa = ({ cartridges, mg, ml, drugPercent }) => {
  if (mg) {
    const ml = mgToMl(mg, drugPercent)
    return {
      cartridges: round(mlToCart(ml)),
      ml: round(ml),
      mg: Number(mg),
    }
  }

  if (ml) {
    return {
      cartridges: round(mlToCart(ml)),
      ml: round(Number(ml)),
      mg: round(mlToMg(ml, drugPercent)),
    }
  }

  if (cartridges) {
    const ml = cartToMl(cartridges)
    return {
      cartridges: round(Number(cartridges)),
      ml: round(ml),
      mg: round(mlToMg(ml, drugPercent)),
    }
  }

  return { ml: 0, mg: 0, cartridges: 0 }
}
